import Api from '@common/services/api';
import { RatingScalePayload } from '../types';

export const createRatingScale = async (
  organisationId: string,
  payload: RatingScalePayload | RatingScalePayload[]
) => {
  const { data } = await Api.post(
    `/v1/organisations/${organisationId}/performance/rating-scales`,
    payload as any
  );

  return { data };
};
